<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('General') }}</span>
      </template>

      <account-setting-general
        v-if="options.email"
        :general-data="options"/>
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Change Password') }}</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- notification -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        v-if="options.email"
        :notification-data="options"
      />
    </b-tab>
    <!-- Display Signature -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="PenToolIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Display Signature') }}</span>
      </template>

      <account-setting-display-signature
        v-if="options.email"
        :display-signature-data="options"
      />
    </b-tab>
    <!-- Display Stripe -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon
          icon="FileTextIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Billing information') }}</span>
      </template>

      <account-setting-stripe-infos
        v-if="options.stripe"
        :stripe-infos-data="options.stripe"
      />
    </b-tab>
    <b-tab v-if="this.$store.state.userData.role === 'ADMIN'">
      <!-- title -->
      <template #title>
        <feather-icon
          icon="CodeIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Api Key') }}</span>
      </template>

      <account-api-key
        :apikey="options.apikey"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import Apicall from '@/libs/api-call'
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingNotification from './AccountSettingNotification.vue'
import AccountSettingDisplaySignature from './AccountSettingDisplaySignature.vue'
import AccountSettingStripeInfos from './AccountSettingStripeInfos.vue'
import AccountApiKey from './AccountApiKey.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingNotification,
    AccountSettingDisplaySignature,
    AccountSettingStripeInfos,
    AccountApiKey,
    ToastificationContent
  },
  data() {
    return {
      options: {},
    }
  },
  beforeCreate() {
    const api = new Apicall();
    api.getMyAccountGeneral().then(response => {
      if (response.status === 'OK') { 
        this.options = response.data.data;
        this.options.nopub = parseInt(this.options.nopub);
        this.options.noalert = parseInt(this.options.noalert);
      } else {
        if (response.statuscode === 401) this.$router.push('Login');
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t(response.msg),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    });
  },
}
</script>
